import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Home, Briefcase, Wallet, User, Headphones } from 'lucide-react';
import UserAvatar from './UserAvatar';

export default function ProviderBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, token } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!token) return;
    const fetchUnread = async () => {
      try {
        const res = await axios.get(`${window.location.origin}/api/support-chat/my/unread-count`, { headers: { Authorization: `Bearer ${token}` } });
        setUnread(res.data.unread || 0);
      } catch (e) { /* ignore */ }
    };
    fetchUnread();
    const t = setInterval(fetchUnread, 10000);
    return () => clearInterval(t);
  }, [token, location.pathname]);

  const isActive = (path) => {
    if (path === '/provider') return location.pathname === '/provider';
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/provider', icon: Home, label: 'Home', testId: 'nav-home' },
    { path: '/provider/jobs', icon: Briefcase, label: 'Jobs', testId: 'nav-jobs' },
    { path: '/provider/earnings', icon: Wallet, label: 'Earnings', testId: 'nav-earnings' },
    { path: '/provider/support', icon: Headphones, label: 'Support', testId: 'nav-support', badge: unread },
    { path: '/provider/profile', label: 'Profile', testId: 'nav-profile', isProfile: true },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 z-50" data-testid="provider-bottom-nav">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-colors ${
                active ? 'text-amber-600' : 'text-slate-400 hover:text-slate-600'
              }`}
              data-testid={item.testId}
            >
              {item.isProfile ? (
                user?.profile_image ? (
                  <UserAvatar src={user.profile_image} name={user?.name} role="provider" size="xs" />
                ) : (
                  <User className={`w-6 h-6 ${active ? 'stroke-[2.5]' : ''}`} />
                )
              ) : (
                <item.icon className={`w-6 h-6 ${active ? 'stroke-[2.5]' : ''}`} />
              )}
              {item.badge > 0 && (
                <span className="absolute top-0 right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center" data-testid="support-unread-badge">
                  {item.badge}
                </span>
              )}
              <span className={`text-xs ${active ? 'font-medium' : ''}`}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
